import React from "react";
import Helmet from "react-helmet";

export default () => (
	<div className="page-wrapper">
		<Helmet title={`About Us - Falken's Party Supplies`} />
		<section id="primary-hero" className="about-hero">
	    	<h1>About Us</h1>
	    	<p>blah blah. something for seo reasons</p>
	  	</section>
	  	<section className="basic-page">
	  		<div className="container">
	  			<p>blah blah</p>
	  		</div>
	  	</section>
  	</div>
);


// WEBPACK FOOTER //
// ./src/pages/about.js